import { round } from "./fable_modules/fable-library.3.7.14/Util.js";
import { fill } from "./Render.Primitives.fs.js";
import { Texture } from "./Model.Platform.fs.js";
import { textureColor, textureStripOffset, spriteOffsets, setPixel as setPixel_1, getPixel as getPixel_1 } from "./Graphics.Common.fs.js";
import { canvasFromTexture, spriteColorIsTransparent } from "./Graphics.fs.js";
import { StatusBar_drawStatusBar, Dissolve_render, Weapons_drawPlayerWeapon, Walls_draw, Objects_draw } from "./CrossPlatform/Render.fs.js";

const viewportZoom = 2;

const zoom = 2;

const wolfViewportWidth = 304;

const wolfViewportHeight = 152;

function getViewportPosition(context) {
    const totalZoomedWidth = (wolfViewportWidth * zoom) * viewportZoom;
    const left = (context.canvas.width / 2) - (totalZoomedWidth / 2);
    const totalZoomedHeight = (wolfViewportHeight * zoom) * viewportZoom;
    const statusBarHeight = (35 * zoom) * viewportZoom;
    const statusBarViewportSpace = round(statusBarHeight / 5);
    const totalHeight = (totalZoomedHeight + statusBarHeight) + statusBarViewportSpace;
    const top = (context.canvas.height / 2) - (totalHeight / 2);
    return [left, top, (top + totalZoomedHeight) + statusBarViewportSpace, totalZoomedWidth, totalZoomedHeight];
}

function drawFrame(context) {
    context.fillStyle = "#004040";
    context.fillRect(0, 0, context.canvas.width, context.canvas.height);
    const patternInput = getViewportPosition(context);
    const totalZoomedWidth = patternInput[3];
    const totalZoomedHeight = patternInput[4];
    const left_1 = patternInput[0] - 1;
    const top_1 = patternInput[1] - 1;
    context.strokeStyle = "#007070";
    context.beginPath();
    context.moveTo(left_1, (top_1 + totalZoomedHeight) + 1);
    context.lineTo((left_1 + totalZoomedWidth) + 1, (top_1 + totalZoomedHeight) + 1);
    context.lineTo((left_1 + totalZoomedWidth) + 1, top_1);
    context.stroke();
    context.lineCap = "square";
    context.strokeStyle = "#000000";
    context.beginPath();
    context.moveTo(left_1, (top_1 + totalZoomedHeight) + 1);
    context.lineTo(left_1, top_1);
    context.lineTo((left_1 + totalZoomedWidth) + 1.5, top_1);
    context.stroke();
}

export function draw(context, bufferContext, statusBarGraphics, graphics_0, graphics_1, sprites, game) {
    const graphics = [graphics_0, graphics_1];
    const startTime = performance.now();
    context.save();
    context.imageSmoothingEnabled = false;
    context.lineCap = "square";
    context.translate(0.5, 0.5);
    context.font = "30px Consolas, Menlo, monospace";
    bufferContext.imageSmoothingEnabled = false;
    const viewportWidth = bufferContext.canvas.width;
    const viewportHeight = bufferContext.canvas.height;
    fill(bufferContext, 3750201, -1, -1, viewportWidth + 1, viewportHeight / 2);
    fill(bufferContext, 7566195, -1, viewportHeight / 2, viewportWidth + 1, (viewportHeight / 2) + 1);
    const outputImageData = bufferContext.getImageData(0, 0, viewportWidth, viewportHeight);
    const outputTexture = new Texture(new Uint32Array(outputImageData.data.buffer), new Uint8ClampedArray(outputImageData.data.buffer), bufferContext.canvas, ~(~viewportWidth), ~(~viewportHeight));
    const getPixel = getPixel_1;
    const setPixel = (color, x_1, y_1) => {
        setPixel_1(outputTexture, color, x_1, y_1);
    };
    const isTransparent = spriteColorIsTransparent;
    const firingHitGameObjectIndexOption = Objects_draw(viewportWidth, viewportHeight, getPixel, setPixel, isTransparent, (spriteIndex) => spriteOffsets(graphics[0], graphics[1], spriteIndex), game, sprites, Walls_draw(viewportWidth, viewportHeight, setPixel, (textureIndex, textureX) => textureStripOffset(graphics[0], graphics[1], textureIndex, textureX), (textureOffset, textureY) => textureColor(graphics[0], graphics[1], textureOffset, textureY), game));
    Weapons_drawPlayerWeapon(bufferContext.canvas.width, bufferContext.canvas.height, getPixel, setPixel, isTransparent, game);
    Dissolve_render(setPixel, game);
    drawFrame(context);
    const patternInput = getViewportPosition(context);
    const left = patternInput[0];
    const imageData_1 = new ImageData(outputTexture.ClampedData,outputTexture.Width,outputTexture.Height);
    bufferContext.putImageData(imageData_1, 0, 0);
    context.drawImage(bufferContext.canvas, left, patternInput[1], viewportWidth * zoom, viewportHeight * zoom);
    context.save();
    context.translate(left, patternInput[2]);
    StatusBar_drawStatusBar(statusBarGraphics, (texture, x_2, y_2) => {
        const totalZoom = zoom * viewportZoom;
        const height = texture.Height * totalZoom;
        const width = texture.Width * totalZoom;
        const y_3 = y_2 * totalZoom;
        const x_3 = x_2 * totalZoom;
        context.drawImage(canvasFromTexture(texture), x_3, y_3, width, height);
    }, game);
    context.restore();
    const matchValue = game.ViewportFilter;
    if (matchValue.tag === 1) {
        const overlay = matchValue.fields[0];
        context.fillStyle = (`rgba(${overlay.Red},${overlay.Green},${overlay.Blue},${overlay.Opacity})`);
        context.fillRect(-1, -1, context.canvas.width + 2, context.canvas.height + 2);
    }
    const endTime = performance.now();
    context.restore();
    return firingHitGameObjectIndexOption;
}

export function initScene(canvas, _arg1) {
    const context = canvas.getContext('2d');
    let patternInput;
    const bufferCanvas = document.createElement("canvas");
    bufferCanvas.width = (wolfViewportWidth * viewportZoom);
    bufferCanvas.height = (wolfViewportHeight * viewportZoom);
    patternInput = [bufferCanvas.getContext('2d'), ~(~bufferCanvas.width), ~(~bufferCanvas.height)];
    return [(statusBarGraphics) => ((tupledArg) => ((sprites) => ((game) => draw(context, patternInput[0], statusBarGraphics, tupledArg[0], tupledArg[1], sprites, game)))), patternInput[1], patternInput[2]];
}

